import { Box } from '@chakra-ui/react'
import { MemberSearchResults } from '@src/components/sco/Members/MemberSearchResults'
import { MembersPage } from '@src/components/sco/Members/MembersLayout'
import { MembersMainPanel } from '@src/components/sco/Members/MembersLayout/MembersMainPanel'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import React from 'react'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default MembersPage(function Page() {
  const activeContent = useActiveContentContext()
  const { getBreakpointValue } = useBreakpointContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('members.search')
    activeContent.setBreadcrumbs([
      {
        title: 'Members',
        href: '/members',
      },
      {
        title: 'Founder Directory',
        href: '/founders',
      },
    ])
  })

  return (
    <MembersMainPanel>
      <Box marginX={'auto'} maxWidth={'1480px'} padding={getBreakpointValue(['1em', '1em', '2em'])}>
        <MemberSearchResults title={'Founder Directory'} />
      </Box>
    </MembersMainPanel>
  )
})
